import React from "react";
import KanbanColumn from "./KanbanColumn";

const COLUMNS = [
    { key: "pending", titleKey: "monitoring.kanban.pending", statuses: ["pending"] },
    { key: "running", titleKey: "monitoring.kanban.running", statuses: ["running"] },
    { key: "completed", titleKey: "monitoring.kanban.completed", statuses: ["completed"] },
    { key: "failed", titleKey: "monitoring.kanban.failed", statuses: ["failed"] },
];

function ExecutionCardGrid({ filters, getEffectiveStatus, onViewDetails }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 h-full">
            {COLUMNS.map((col) => (
                <KanbanColumn
                    key={col.key}
                    columnKey={col.key}
                    titleKey={col.titleKey}
                    statuses={col.statuses}
                    filters={filters}
                    getEffectiveStatus={getEffectiveStatus}
                    onViewDetails={onViewDetails}
                />
            ))}
        </div>
    );
}

export default ExecutionCardGrid;
